import React from 'react'
import AboutHero from '../components/AboutHero/AboutHero'
import CoreServices from '../components/CoreServices/CoreServices'
import WhyChoose from '../components/WhyChoose/WhyChoose'
import BookingSection from '../components/BookingSection/BookingSection'
import Footer from '../components/Footer/Footer'
import { Helmet } from 'react-helmet'

const Services = () => {
    return (
        <div className='bg-black'>
            <Helmet>
                <title>Elite Optix Services | Comprehensive Eye Care & Designer Eyewear</title>
                <meta
                    name="description"
                    content="Discover Elite Optix's comprehensive eye care services, advanced lens technology, and curated designer eyewear collections. Book your appointment today!"
                ></meta>
                <link
                    rel="canonical"
                    href="https://eliteoptix.com/services"
                />
            </Helmet>
            <AboutHero page="services" img={"/services-hero.png"} title="Precision Eye Care Meets Designer Eyewear" subtitle="Comprehensive eye exams, advanced lens technology and a curated collection of designer frames. See clearly, feel confident, and make every look a statement." />
            <div className="bg_gradient">
                <CoreServices />
                <WhyChoose />
                <BookingSection />
            </div>
            <Footer />
        </div>
    )
}

export default Services